var tooltipTimer = null;
document.querySelectorAll(".tooltip-trigger").forEach(function(obj) {
  obj.addEventListener("click", function(e) {
    openTooltip(obj);

    if(tooltipTimer) {
      clearTimeout(tooltipTimer);
    }
  });
});

function openTooltip(obj) {
  document.querySelectorAll(".ingredient-tooltip").forEach(function(obj) {
    obj.classList.add("hide");
  });
  var tooltip = obj.closest(".ingredient-item").querySelector(".ingredient-tooltip");
  if(obj.classList.contains("opened")) {
    tooltip.classList.add("hide");
    obj.classList.remove("opened");
  }
  else {
    tooltip.classList.remove("hide");
    obj.classList.add("opened");
  }
}

window.addEventListener("click", function(e) {
  if(e.target.classList.contains("tooltip-trigger") || e.target.closest(".tooltip-trigger") || e.target.closest(".ingredient-tooltip") || e.target.classList.contains("ingredient-tooltip")) {}
  else {
    document.querySelectorAll(".ingredient-tooltip").forEach(function(obj1) {
      obj1.classList.add("hide");
      obj1.closest(".ingredient-item").querySelector(".tooltip-trigger").classList.remove("opened");
    });
  }
});

document.querySelectorAll(".product-additional-info .tab-header").forEach(function(obj) {
  obj.addEventListener("click", function(e) {
    var ind = obj.getAttribute("data-for");

    document.querySelector(".product-additional-info .tab-header.active").classList.remove("active");
    obj.classList.add("active");
    document.querySelector(".product-additional-info .tab-content.active").classList.remove("active");
    document.querySelector(".product-additional-info .tab-content[data-index='" + ind + "']").classList.add("active");
  });
});

jQuery(document).ready(function($) {
  $(".flickity_slider:not(.recently-viewed-grid)").flickity({
    cellAlign: 'left',
    contain: true,
    draggable: true,
    groupCells: '100%',
    pageDots: false,
    on: {
      ready: function() {
        $(".flickity_slider").css("opacity", 1);
        $(".flickity_slider").css("height", "auto");
      }
    }
  });

  
  $(document).on("click", ".cart-quick-edit-js", function(e) {
    e.preventDefault();
    // $(".drawer__close").trigger("click");
    $("body").addClass("quick-cart-update-loading");
    var addedID = $(this).parents("tr.cart-item").attr("data-id");
    $(this).parents("tr.cart-item").find(".cart-quick-edit-wrap button").trigger("click");
    var popupOpenTimer = setInterval(function(){
      var popupSelector = $("quick-add-modal[open]");
      if(popupSelector.length){
        var proVariantsHTML = popupSelector.find("#hidden-selected-variant").html();
        var proVariants = $.parseJSON(proVariantsHTML);
        var addedVariant = proVariants[addedID];

        // Show cart added variant as default
        if(popupSelector.find("product-info variant-radios fieldset").length){
          popupSelector.find("product-info variant-radios fieldset").each(function(i, value){
            var varLabel = $(this).find(".form__label").text().trim().toLowerCase().replaceAll(" ", "_");
            var varValue = addedVariant[varLabel];
            $(this).find("input").each(function(){
              if($(this).val() == varValue){
                $(this).next("label").trigger("click");
              }
            });
          });
        }

        var updatedID = popupSelector.find("form .product-variant-id").val();
        popupSelector.find(".product-form__input input").change(function(){
          setTimeout(function(){
            updatedID = popupSelector.find("form .product-variant-id").val();
          }, 500);
        });

        popupSelector.find("form").on("submit", function(){
          if(addedID != updatedID){
            setTimeout(function(){
              removeCartProduct(addedID);
            }, 1000);
          }
        });
        $("body").removeClass("quick-cart-update-loading");
        clearInterval(popupOpenTimer);
      }
    }, 1000);
  });

  function removeCartProduct(vID){
    var data = {
      'id': vID,
      'quantity': 0
    };
    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: data,
      dataType: 'json',
      success: function(cart) {
            refreshCartContent();

          // init cart product slider
          setTimeout(function(e){
            initCartRecommendSlider();
          },1000);
      }
    }); 
  }

  /*
  $(document).on("click", ".cart-edit1", function(e) {
    var hdl = $(this).parents(".cart-item").attr("data-handle");
    var id = $(this).parents(".cart-item").attr("data-id");
    var qty = $(this).parents(".cart-item").find(".quantity__input").val();

    jQuery.ajax({
      type : "get", 
      dataType : "json", 
      url : "/products/" + hdl + ".js",
      success : function(response) {

        var selVariant = null;
        for(var i = 0; i < response.variants.length; i ++) {
          var va = response.variants[i];
          if(va.id == id) {
            selVariant = va;
            break;
          }
        }

        if(!selVariant) { return; }

        var option_html = '';
        for(var j = 0; j < response.options.length; j ++) {
          var opt = response.options[j];

          option_html += "<div class='option'>"
                          + "<div class='option_name'><span>" + opt.name + ": </span><span class='selOptVal'>" + selVariant.options[j] + "</span></div>";
          for(var k = 0; k < opt.values.length; k ++) {
            if(selVariant.options[j] == opt.values[k]) {
              option_html += "<button class='option_swatch selected'>" + opt.values[k] + "</button>"
            }
            else {
              option_html += "<button class='option_swatch'>" + opt.values[k] + "</button>"
            }
          }
          option_html += "</div>";
        }

        var variantSel = "<select class='variantSel hide'>";
        for(j = 0; j < response.variants.length; j ++) {
          var va = response.variants[j];

          variantSel += '<option data-title="' + va.title.trim() + '" value="' + va.id + '">' + '</option>';
        }
        variantSel += "</select>";
        var item_html = "<div class='item' data-currentid='" + id + "' data-id='" + selVariant.id + "' data-qty='" + qty + "'>"
                        + "<div class='col col-image'>"
                          + "<img src='" + response.featured_image + "'>"
                        + "</div>"
                        + "<div class='col col-content'>"
                          + "<h3>" + response.title + "</h3>"
                          + "<span class='variant-title'>" + selVariant.public_title + "</span>"
                          + "<span class='price'>" + Shopify.formatMoney(selVariant.price, Shopify.money_format) + "</span>"
                        + "</div>"
                        + "<div class='col col-options'>"
                          + option_html
                        + "</div>"
                        + variantSel
                      + "</div>";

        $(".product-editor-popup .items").html(item_html);
        $(".product-editor-popup").removeClass("hide");
      },
      error : function(response) {
        console.log("ERROR");
        console.log(response);
      }
    });
  });
  */

  $(".product-editor-popup .close").on("click", function(e) {
    $(this).parents(".product-editor-popup").addClass("hide");
  });

  $(document).on("click", ".qty_btn.qty_plus", function(e) {
    var qty_inp = $(this).parent().find(".qty_inp");
    var qty = parseInt(qty_inp.val());

    qty_inp.val(qty + 1);
  });

  $(document).on("click", ".qty_btn.qty_minus", function(e) {
    var qty_inp = $(this).parent().find(".qty_inp");
    var qty = parseInt(qty_inp.val());

    if(qty > 1) {
      qty_inp.val(qty - 1);
    }
  });
});

function initCartRecommendSlider(){
  var len =  $(".cart_recommend.flickity_slider:not(.recently-viewed-grid)").length;
  if(len > 0 && !$(".cart_recommend").hasClass("flickity-enabled")){
    $(".cart_recommend.flickity_slider:not(.recently-viewed-grid)").flickity({
      cellAlign: 'left',
      contain: true,
      draggable: true,
      groupCells: '100%',
      pageDots: false,
      on: {
        ready: function() {
          $(".flickity_slider").css("opacity", 1);
          $(".flickity_slider").css("height", "auto");
        }
      }
    });
  }
}

document.addEventListener("recentlyviewed_loaded", function(e) {
  setTimeout(function() {
    jQuery(".recently-viewed-wrapper .flickity_slider").flickity({
      cellAlign: 'left',
      contain: true,
      draggable: true,
      groupCells: '100%',
      pageDots: false,
      on: {
        ready: function() {
          jQuery(".recently-viewed-wrapper .flickity_slider").css("opacity", 1);
          jQuery(".recently-viewed-wrapper .flickity_slider").css("height", "auto");
        }
      }
    });
  }, 1000);
});

function initCustomFilterCLick(){
document.querySelectorAll(".sub-filter-option").forEach(function(obj) {
  obj.addEventListener("click", function(e) {
    var val = obj.getAttribute("data-value");
    var facets_wrapper = obj.closest(".facets-wrapper");
    var inp = facets_wrapper.querySelector(".filter-options input[value='" + val + "']");
    if(obj.classList.contains("active")) {
      obj.classList.remove("active");
      inp.checked = false;
    }
    else {
      obj.classList.add("active");
      inp.checked = true;
    }
    
    document.querySelector("facet-filters-form form").dispatchEvent(new Event('input', { bubbles: true }));
  });
});
}
initCustomFilterCLick();


  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });


  $( ".footer__content-top .footer-block__heading" ).click(function() {
    $(this).toggleClass("active"); 
    $(this).next( ".footer-block__details-content.list-unstyled" ).slideToggle("slow");
  });

  $('.edit-del_cover .edit-address-btn').on('click',function(e) {
    var id = $(this).attr('aria-controls'); 
    if($('#'+id).hasClass('active_edit')){
      $('#'+id).removeClass('active_edit');     
    }else{
      $('#'+id).addClass('active_edit');   
    } 
 })

$('.edit-address-close').on('click',function(e) {
  e.preventDefault(); 
  $(this).closest('.edit_address_form').removeClass('active_edit') 
  return false; 
})

  $(window).on("scroll", () => {
    $("#ProductGridContainer").each(function() {
      //var className = $(this).attr("touching")
      var offset = $(this).offset().top - $(window).scrollTop() ;
      if (offset <= 0) {
        $('body').addClass('filter-sticky-active')
      } else {
        $('body').removeClass('filter-sticky-active')
      }
    })
  }).trigger("scroll")



  $('#language-modal .btn-save').on('click',function(e) {
    e.preventDefault();
    var val = $("#language-modal input[name='language']:checked").val();
    $('.disclosure__list-wrapper li a[data-value="'+val+'"]')[0].click(); 
    return false; 
 })

$(".background-overlay").on("click", function(e) {
  $("body").removeClass("is-open-drawer");
});

$(document).on("click", ".tooltip-grind_type .tooltip-trigger", function(e) {
  document.querySelector(".grind_type-popup").classList.remove("hide");
});

$(document).on("click", ".grind_type-popup .btn-close", function(e) {
  $(this).parents(".grind_type-popup").addClass("hide");
});

$(document).on("click", ".product-editor-popup .col-options .option_swatch", function(e) {
  var item = $(this).parents(".item");
  $(this).parents(".option").find(".option_swatch.selected").removeClass("selected");
  $(this).addClass("selected");
  var selOpts = item.find(".option_swatch.selected");

  var sel_str = '';
  for(var i = 0; i < selOpts.length; i ++) {
    var op = selOpts.eq(i);
    if(i > 0) {
      sel_str += ' / ';
    }

    sel_str += op.text().trim();
  }
  sel_str = sel_str.trim();

  var id = item.find(".variantSel option[data-title='" + sel_str + "']").val();
  item.attr("data-id", id);
});

$(document).on("click", ".product-editor-popup .btn-add_to_cart", function(e) {
  var popup = $(this).parents(".product-editor-popup");
  var item = popup.find(".item");
  var currentid = item.attr("data-currentid");
  var newid = item.attr("data-id");

  if(newid == currentid) {
    popup.find(".close").trigger("click");
  }
  else {
    popup.find(".btn-add_to_cart").attr("disabled", "disabled");
    var data1 = {
      'id': item.attr("data-currentid"),
      'quantity': 0
    };
    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: data1,
      dataType: 'json',
      success: function(cart1) {
        var data = {
          "quantity": item.attr("data-qty"),
          "id": item.attr("data-id")
        }
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add',
          data: data,
          dataType: 'json',
          success: function(cart) { 
            refreshCartContent();
          }
        });
      }
    }); 
  }
});




function initCustomPriceFilter(){
  if(!$(".custom-price-range-desktop").length) return false;
  var filterWrap = $(".custom-price-range-desktop").parents("details").find("ul.no-js-hidden");
  
  var minVal, maxVal;
  var selMinVal, selMaxVal;
  filterWrap.find("li").each(function(){
    if($(this).find("input:not(:disabled)").length){
      if(minVal == undefined) minVal = parseFloat($(this).find("input").val());
      maxVal = parseFloat($(this).find("input").val());

      if($(this).find("input").is(":checked")){
        if(selMinVal == undefined) selMinVal = parseFloat($(this).find("input").val());
        selMaxVal = parseFloat($(this).find("input").val());
      }
    }
  });

  if(selMinVal == undefined && selMaxVal == undefined){
    selMinVal = minVal;
    selMaxVal = maxVal;
  }
  minAdjustVal = (Math.ceil(minVal)) - minVal;
  maxAdjustVal = (Math.ceil(maxVal)) - maxVal;

  setTimeout(function(){
    $(".custom-price-range-input .min-price").val(selMinVal.toFixed(2)).attr("min", minVal);
    $(".custom-price-range-input .max-price").val(selMaxVal.toFixed(2)).attr("max", maxVal); 

    $( "#slider-range-desktop").slider({
      range: true,
      min: minVal - 1,
      max: maxVal + 1,
      step: 0.1,
      values: [ selMinVal, selMaxVal ],
      slide: function( event, ui ) {
        if(Math.abs(ui.values[ 0 ] - $(".custom-price-range-input .min-price").val()) > 1){
          $(".custom-price-range-input .min-price").val((ui.values[ 0 ]).toFixed(2)).attr("max", (ui.values[ 0 ]).toFixed(2));
        }
        if(Math.abs(ui.values[ 1 ] - $(".custom-price-range-input .max-price").val()) > 1){
          $(".custom-price-range-input .max-price").val((ui.values[ 1 ]).toFixed(2)).attr("max", (ui.values[ 1 ]).toFixed(2));
        }
        $(".custom-price-range-input input").trigger("change");       
      }
    });

    $( "#slider-range-mobile").slider({
      range: true,
      min: minVal - 1,
      max: maxVal + 1,
      step: 0.1,
      values: [ selMinVal, selMaxVal ],
      slide: function( event, ui ) {
        if(Math.abs(ui.values[ 0 ] - $(".custom-price-range-input .min-price").val()) > 1){
          $(".custom-price-range-input .min-price").val((ui.values[ 0 ]).toFixed(2)).attr("max", (ui.values[ 0 ]).toFixed(2));
        }
        if(Math.abs(ui.values[ 1 ] - $(".custom-price-range-input .max-price").val()) > 1){
          $(".custom-price-range-input .max-price").val((ui.values[ 1 ]).toFixed(2)).attr("max", (ui.values[ 1 ]).toFixed(2));
        }
        $(".custom-price-range-input input").trigger("change");
      }
    });
  },500);

  showOnlyMinMaxPriceTags($(".active-facets-mobile"));
  showOnlyMinMaxPriceTags($(".active-facets-desktop"));
}
initCustomPriceFilter();

function showOnlyMinMaxPriceTags(filtertags){
  var priceMinTag, priceMaxTag;
  filtertags.find("facet-remove").each(function(){
    if($(this).find(".active-facets__button-inner").text().indexOf("Preis pro kg") != -1 || $(this).find(".active-facets__button-inner").text().indexOf("Price per kg") != -1){
      if(priceMinTag == undefined){ priceMinTag = $(this); }
      priceMaxTag = $(this);
      $(this).hide();
    }
  });
  
  if(priceMinTag != undefined && priceMaxTag != undefined){
    var minPrice = priceMinTag.find("a").attr("data-val");
    var maxPrice = priceMaxTag.find("a").attr("data-val");
    if(minPrice != undefined && maxPrice != undefined){
      var tagLabel = priceMaxTag.find(".active-facets__button-inner").text().trim().split(":")[0];
      var tagSvg = priceMaxTag.find(".active-facets__button-inner > svg");
      var tagSpan = priceMaxTag.find(".active-facets__button-inner > span");
      //priceMinTag.show();
      priceMaxTag.show();
      priceMaxTag.find(".active-facets__button-inner").text(tagLabel + ": " + getGermanPrice(minPrice) + " - " + getGermanPrice(maxPrice));
      priceMaxTag.find(".active-facets__button-inner").append(tagSvg);
      priceMaxTag.find(".active-facets__button-inner").append(tagSpan);
      priceMaxTag.find("a").addClass("price-reset-js");
    }
  } 
}

function getGermanPrice(price){
  var tmpPrice = price.toString();
  if(tmpPrice.indexOf(".") == -1){
    tmpPrice = tmpPrice + ",00"
  }
  tmpPrice = tmpPrice.replace(".", ",");
  if(tmpPrice.split(",")[1].length == 1) tmpPrice += "0";
  return tmpPrice;
}


$(document).on("click", ".price-reset-js", function(e){
  e.preventDefault();
  window.location.href = $(".custom-price-range-desktop-cover facet-remove a").attr("href");
});

$(document).on("change keyup", ".custom-price-range-input input", function(){
  var filterWrap;
  if($(".custom-price-range-mobile").is(":visible")){
    filterWrap = $(this).parents(".custom-price-range-mobile-cover").find("ul.mobile-facets__list");
  }else{
    filterWrap = $(this).parents(".custom-price-range-desktop-cover").find("ul.no-js-hidden");
  }
  var priceFilterTime;
  if(priceFilterTime) clearTimeout(priceFilterTime);
  priceFilterTime = setTimeout(function(){
    var minVal = $(".custom-price-range-input .min-price").val();
    var maxVal = $(".custom-price-range-input .max-price").val();
    triggerCustomPriceFilter(filterWrap, minVal, maxVal);
  }, 500);
});

function triggerCustomPriceFilter(filterWrap, minVal, maxVal){
  filterWrap.find("li").each(function(){
    var currVal = parseFloat($(this).find("input").val());
    if(currVal >= minVal && currVal <= maxVal){
      if(!$(this).find("input").is(":checked")){
        $(this).find("label").trigger("click");
      }
    }else{
      if($(this).find("input").is(":checked")){
        $(this).find("label").trigger("click");
      }
    }
  });
}

function refreshCartContent(){
  // Cart drawer update
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const sourceQty = html.querySelector('cart-drawer');
    document.querySelector('cart-drawer').innerHTML = sourceQty.innerHTML;
  })
  .catch((e) => {
    console.error(e);
  }).finally(function(){
    contentHideShow()
  });
  /*
  popup.find(".btn-add_to_cart").prop("disabled", false);
  popup.find(".close").trigger("click");
  */

  // Cart page update
  fetch(`${routes.cart_url}?section_id=main-cart-items`)
    .then((response) => response.text())
    .then((responseText) => {
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const sourceQty = html.querySelector('cart-items');
    if($("cart-items").length){
      document.querySelector('cart-items').innerHTML = sourceQty.innerHTML;
    }
    if($("cart-items form .cart__items .cart-items").length){
      $("cart-items").removeClass("is-empty");
    }else{
      $("cart-items").addClass("is-empty");
    }
  })
  .catch((e) => {
    console.error(e);
  }).finally(function(){
    contentHideShow()
  });;
  fetch(`${routes.cart_url}`)
    .then((response) => response.text())
    .then((responseText) => {
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const sourceQty = html.querySelector('main-cart-footer');
    if($("main-cart-footer").length){
      document.querySelector('main-cart-footer').innerHTML = sourceQty.innerHTML;
    }

    const countBubble = html.querySelector('.cart-count-bubble');
    if($(".cart-count-bubble").length){
      document.querySelector('.cart-count-bubble').innerHTML = countBubble.innerHTML;
    }
  })
  .catch((e) => {
    console.error(e);
  }).finally(function(){
    contentHideShow();
    initCartRecommendSlider();
  });;

}
refreshCartContent();

function contentHideShow(){
  if($("table.cart-items tr").length){
   // $(".drawer__freeshipping").show();
    $(".cart-recommendation-wrapper").show();
   // $(".cart-drawer__footer").show();
   // $(".drawer__footer").show();
  }else{
   // $(".drawer__freeshipping").hide();
    $(".cart-recommendation-wrapper").hide();
   // $(".cart-drawer__footer").hide();
   // $(".drawer__footer").hide();
  }
}

// Function to show the error message
function showError() {
  const errorMessage = document.querySelector(".form__message");
  if (errorMessage) {
    errorMessage.classList.remove("hidden"); // Remove the "hidden" class to show the error message
  }
}

// Cache constant elements to avoid repeated DOM queries
const accountLink = document.querySelector(".account-drawer-click");

// Define a function to handle the click event
function handleButtonClick(e) {
  const targetId = e.target.id || "";
  
  if (e.target.classList.contains("ssw-fave-btn-content") || e.target.classList.contains("ssw-icon-heart-o")) {
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta.page.customerId === undefined) {
      const closeButton = document.querySelector(".quick-add-modal__toggle");
      
      if (closeButton) {
        closeButton.click();
      }
      
      if (accountLink) {
        localStorage.setItem('lastProductPageBeforeLogin', window.location.href);
        // Emit a custom event after setting the item in localStorage
        const event = new Event('UserClickedWishlist');
        document.dispatchEvent(event);
        accountLink.click();
        showError();
      }
    }
  }
}

const wishlistButton = document.querySelector(".ssw-fave-btn-content");

if (wishlistButton) {
  wishlistButton.addEventListener("click", function (e) {
    handleButtonClick(e);
  });
}

// Create a MutationObserver to watch for changes in the DOM
const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
      // New nodes have been added to the DOM, attach the click event listener
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          node.addEventListener("click", handleButtonClick);
        }
      });
    }
  }
});

// Start observing changes in the DOM, you can target a specific container or the document
observer.observe(document, { childList: true, subtree: true });

